import { render, staticRenderFns } from "./TokenPricedModal.vue?vue&type=template&id=543dee2a"
import script from "./TokenPricedModal.vue?vue&type=script&lang=ts"
export * from "./TokenPricedModal.vue?vue&type=script&lang=ts"
import style0 from "./TokenPricedModal.vue?vue&type=style&index=0&id=543dee2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports